var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "lending-schedule-panel" },
    [
      _c(
        "b-card",
        [
          _vm.showStoreFilter
            ? _c(
                "b-row",
                { staticClass: "mb-1" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "lending-schedule-panel-store",
                          value: _vm.storeId,
                          required: false,
                          clearable: true,
                          "select-single-option": false,
                          placeholder: _vm.$t("Todas as lojas"),
                        },
                        on: { input: _vm.onStoreChanged },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading, rounded: "sm", opacity: "0.4" } },
            [
              _c("full-calendar", {
                ref: "calendar",
                attrs: { options: _vm.calendarOptions },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-lending-schedule-detail",
            title: _vm.detailTitle,
            centered: "",
            size: "md",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c("e-button", {
                    staticClass: "mr-1",
                    attrs: {
                      id: "modal-lending-schedule-detail-btn_close",
                      variant: "outline-primary",
                      text: _vm.$t("Fechar"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.showDetail = false
                      },
                    },
                  }),
                  _c("e-button", {
                    attrs: {
                      id: "modal-lending-schedule-detail-btn_open_order",
                      variant: "primary",
                      text: _vm.$t("Abrir pedido"),
                    },
                    on: { click: _vm.openOrder },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showDetail,
            callback: function ($$v) {
              _vm.showDetail = $$v
            },
            expression: "showDetail",
          },
        },
        [
          _vm.selected
            ? [
                _c(
                  "dl",
                  { staticClass: "row mb-0" },
                  [
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Horário")) + " "),
                    ]),
                    _c("dd", { staticClass: "col-sm-8" }, [
                      _vm._v(
                        " " + _vm._s(_vm.formatPeriod(_vm.selected)) + " "
                      ),
                    ]),
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Cliente")) + " "),
                    ]),
                    _c("dd", { staticClass: "col-sm-8" }, [
                      _vm._v(
                        " " + _vm._s(_vm.selected.customerName || "-") + " "
                      ),
                    ]),
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Loja")) + " "),
                    ]),
                    _c("dd", { staticClass: "col-sm-8" }, [
                      _vm._v(" " + _vm._s(_vm.selected.storeName || "-") + " "),
                    ]),
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Status do pedido")) + " "),
                    ]),
                    _c("dd", { staticClass: "col-sm-8" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.saleStatusLabel[_vm.selected.status] ||
                              _vm.selected.status
                          ) +
                          " "
                      ),
                    ]),
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Status da entrega")) + " "),
                    ]),
                    _c(
                      "dd",
                      { staticClass: "col-sm-8" },
                      [
                        _c(
                          "b-badge",
                          {
                            attrs: {
                              variant: _vm.deliveryStatusVariant(
                                _vm.selected.deliveryStatus
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.deliveryStatusLabel[
                                    _vm.selected.deliveryStatus
                                  ] || "-"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Endereço")) + " "),
                    ]),
                    _c("dd", { staticClass: "col-sm-8" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatAddress(_vm.selected.deliveryAddress)
                          ) +
                          " "
                      ),
                    ]),
                    _vm.selected.deliveryObservation
                      ? [
                          _c("dt", { staticClass: "col-sm-4" }, [
                            _vm._v(" " + _vm._s(_vm.$t("Observação")) + " "),
                          ]),
                          _c("dd", { staticClass: "col-sm-8" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.selected.deliveryObservation) +
                                " "
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _c("dt", { staticClass: "col-sm-4" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Itens de comodato")) + " "),
                    ]),
                    _c("dd", { staticClass: "col-sm-8" }, [
                      _vm.selected.items.length
                        ? _c(
                            "ul",
                            { staticClass: "pl-1 mb-0" },
                            _vm._l(_vm.selected.items, function (item, index) {
                              return _c("li", { key: index }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.quantity) +
                                    " x " +
                                    _vm._s(item.name || "-") +
                                    " "
                                ),
                              ])
                            }),
                            0
                          )
                        : _c("span", [_vm._v("-")]),
                    ]),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }